export const createSummaryInvestTran = (transactionArr, investmentMaster) => {
    
    let summaryTranArr = [];
    let sortedTransactionArr = JSON.parse(JSON.stringify(transactionArr));
    sortedTransactionArr.sort((a, b) => 
        (a.investShortName + a.transactionDate > b.investShortName + b.transactionDate) ? 1 : -1);
    let previousShortName = "";
    let tranQty = 0;
    let firstTranDate = "";
    let dividendPaid = false;
    let investMaster = {};
    for (let i=0; i<sortedTransactionArr.length; i++){
        const transaction = sortedTransactionArr[i];
        if (transaction.investShortName === previousShortName){
            tranQty += +transaction.quantity;
        }else{
            if (previousShortName !== "" && dividendPaid === true){
                const outputTran = 
                    {investShortName: previousShortName, quantity: tranQty, firstBuyDate: firstTranDate,
                        yield: investMaster.dividendInfo.yield, investmentName: investMaster.investmentName,
                        currentPrice: investMaster.currentPrice};
                summaryTranArr.push(outputTran);
            }
            investMaster = 
                investmentMaster.find(elem => elem.investShortName === transaction.investShortName);
            if (investMaster && investMaster.dividendInfo && investMaster.dividendInfo.dividend === true){
                dividendPaid = true;
                tranQty = +transaction.quantity;
                firstTranDate = transaction.transactionDate;
            }else{
                dividendPaid = false;
                tranQty = 0;
                firstTranDate = "";
            }
            previousShortName = transaction.investShortName;
        }
    }
    if (previousShortName !== "" && dividendPaid === true){
        const outputTran = 
            {investShortName: previousShortName, quantity: tranQty, firstBuyDate: firstTranDate,
                yield: investMaster.dividendInfo.yield, investmentName: investMaster.investmentName,
                currentPrice: investMaster.currentPrice};
        summaryTranArr.push(outputTran);
    }
   
    return summaryTranArr;
}
    
export default createSummaryInvestTran;